import { useCallback, useEffect, useRef } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';

import { getWarehouseLayout } from 'repositories/HttpRepository';
import { warehouseLayoutState } from 'atoms/WarehouseLocationSetupState';

export default function useWarehouseLocationLayout(warehouseId) {
  const [{ layout, loaded }, setState] = useRecoilState(warehouseLayoutState);
  const reset = useResetRecoilState(warehouseLayoutState);
  const requestId = useRef(0);

  const reload = useCallback(() => {
    const currentRequest = ++requestId.current;
    return getWarehouseLayout(warehouseId).then((res) => {
      if (currentRequest !== requestId.current) return;
      setState({ layout: res.ok && res.data?.locations ? res.data : null, loaded: true });
    });
  }, [warehouseId, setState]);

  useEffect(() => {
    reload();
    return () => {
      requestId.current += 1;
      reset();
    };
  }, [reload, reset]);

  return { layout, loaded, reload };
}
